module.exports = __webpack_public_path__ + "img/hero_boy_chaos.2718a850.png";